export interface EnvironmentState {
    isStandalone: boolean;
    production: boolean;
}

export const environmentInitialState: EnvironmentState = {
    isStandalone: false,
    production: true,
};
